/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ price: NonNullable<unknown> }} Offers_Per_WeekInputs */

const en_offers_per_week = /** @type {(inputs: Offers_Per_WeekInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} / week`)
};

const pl_offers_per_week = /** @type {(inputs: Offers_Per_WeekInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} / tydz.`)
};

/**
* | output |
* | --- |
* | "{price} / week" |
*
* @param {Offers_Per_WeekInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const offers_per_week = /** @type {((inputs: Offers_Per_WeekInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offers_Per_WeekInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_offers_per_week(inputs)
	return en_offers_per_week(inputs)
});